import { Modal } from "@shapr3d/frontend-lib";

import useTranslation from "../../hooks/useTranslation";
import DeleteAccountForm from "../DeleteAccountForm/DeleteAccountForm";

export default function DeleteAccountModal({
  onClose,
  open,
}: {
  onClose: () => void;
  open: boolean;
}) {
  const { t, m } = useTranslation();
  return (
    <Modal open={open} title={t(m.Account.DeleteAccount.Title)} size="small" onClose={onClose}>
      <DeleteAccountForm open={open} />
    </Modal>
  );
}
